<template>
  <el-form
    :model="form"
    ref="form">
    <div class="row">
      <div class="col-auto">
        <el-form-item
          :label="L10n('name')"
          prop="name"
          :rules="getValidationRule('required,minLength')"
          class="material-style">
          <el-input
            :value="form.name"
            @input="form.name = valueTrimLeft($event)"
            @change="updateModelItem('name', { required: true })"
          />
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-auto">
        <el-form-item
          :label="L10n('user-path')"
          prop="userPath"
          class="material-style">
          <el-input
            :value="form.userPath"
            @input="form.userPath = valueTrimLeft($event)"
            @change="updateModelItem('userPath')"/>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-auto">
        <el-form-item
          prop="isActive"
          class="material-style">
          <el-checkbox
            v-model="form.isActive"
            @change="updateModelItem('isActive')">
            {{L10n('is-active')}}
          </el-checkbox>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormEmployees',
  mixins: [Form]
}
</script>
